exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".list-card[data-v-1c395eac] {\n  display: inline-block;\n  width: 100%;\n}\n", ""]);

